import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { XCircle, XLg } from 'react-bootstrap-icons';
import Popup from 'reactjs-popup';
import styles from './CSPChangeStatus.module.scss';
import { api } from '../../../../../../../../Utils/API';
import { CSP_CANCEL_STATUS_POST, CSP_REACTIVATE_STATUS_POST, CSP_SUSPEND_STATUS_POST } from '../../../../../../../../Utils/GlobalConstants';
import Table from 'react-bootstrap/Table';
import loadingGif from "../../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import { TEXT_SECONDARY, TOAST_ERROR_ICON_COLOR } from '../../../../../../../../Utils/ColorsConfiguration';
import { CancelSubscriptionErrorToast, CancelSubscriptionSuccessToast, CSPSuccessToast, ReactivationgErrorToast, ReactivitingSuccessToast, SubscriptionSuspensionSuccessToast, SuspendSubscriptionErrorToast } from '../../../../../../../../Utils/StaticMessages/ToastMessages';
import { ChangeStatus7DayCancellationNote, ChangeStatusCancellationAllowedNote, CSPChangeStatusNote1, CSPChangeStatusNote2, GWSActivationFlexibleNote, ScheduleDateAllowanceNote, ScheduleDateNote, ScheduleOrderInfoNote } from '../../../../../../../../Utils/StaticMessages/NotesDisclaimers';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { AddVendorRequirementsForPLAMPA } from '../../../../../../../../Utils/StaticMessages/GenericErrorMessages';

const CSPChangeStatus = ({ subscriptionTableAPIData, setSubscriptionTableAPIData, subscriptionId, changeStatusActionPopupModalOpen, setChangeStatusActionPopupModalOpen,
    setToastSuccess, setToastError, setToastMessage, setActionCompletedRefreshSubscriptionTable, isNcePlan, setIsNcePlan, Logout,
setIsActionInProgress,
    setIsAutoRefreshEnabled  }) => {

    const navigate = useNavigate(); // React Router DOM v6
        
    const [confirmSuspendFlag, setConfirmSuspendFlag] = useState(false);                                                                           // Confirmation popup on suspend/reactive/Cancel subscription                                
    const [confirmChangeStatusLoadingFlag, setConfirmChangeStatusLoadingFlag] = useState(false);                                                   // loading check in popup
    let ChangeStatusColumnNameSuspendNce = ["Plan", "SKU ID","Commitment Term (Billing Frequency)", "Reseller Price (Ex GST)", "Quantity", "Refund"];                     // Columns of table for Suspend Nce plan Action 
    let ChangeStatusColumnNameSuspendLegacy = ["Plan","SKU ID", "Commitment Term (Billing Frequency)", "Reseller Price (Ex GST)", "Quantity"];                            // Columns of table for Suspend Legacy plan Action 
    let ChangeStatusColumnNameReActivate = ["Plan","SKU ID", "Commitment Term (Billing Frequency)", "Reseller Price (Ex GST)", "Quantity"];                               // Columns of table for Re-Activate Legacy plan Action
    let ChangeStatusNceColumnNameCancel = ["Plan","SKU ID", "Commitment Term (Billing Frequency)", "Reseller Price (Ex GST)", "Quantity", "Cancellation Allowed Until"];  // Columns of table for Cancel NCE plan Action 
    const [selectedOption, setSelectedOption] = useState(null);                                                                                    // selcted tab whether suspend ,cancel or re-activate is selected in tab at the top                                                                // Selecting tab ie. suspend subscription,cancel subscription or re-activate subscription

     // schedule date
     const [selectedDate, setSelectedDate] = useState("");
     const [showNote, setShowNote] = useState(false);

    //selecting tab option at the top 
    const handleOptionChange = (value) => {
        {
            !subscriptionTableAPIData &&
                <div className={styles["loading-plans"]}><p><b>Loading . . .</b></p></div>
        }
        {
            subscriptionTableAPIData &&
                setSelectedOption(value);
                setSelectedDate("");
                setShowNote(false);
        }
    };

    const handleKeyDown = (e) => {
        e.preventDefault();
      };
    
      const handlePaste = (e) => {
        e.preventDefault();
      };

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    //post api for Change-Status REACTIVATE confirmation
    async function CSPChangeStatusReactivatePost(subscriptionId) {
        setConfirmChangeStatusLoadingFlag(true);
        let requestBody = {
           "subscriptionId": subscriptionId ,
           "scheduledDate": selectedDate ? new Date(new Date(selectedDate).getTime() + 19800000).toISOString().split('T')[0] : "",
           "planId": parseInt(subscriptionTableAPIData.planId)
        };
        await api.post(CSP_REACTIVATE_STATUS_POST, requestBody, config)
            .then(resp => {
                if (resp.status = 200) {
                    setConfirmChangeStatusLoadingFlag(false);
                    setSubscriptionTableAPIData(null);
                    setChangeStatusActionPopupModalOpen(false);
                    setToastMessage(resp.data.isOrderScheduled ? resp.data.scheduleOrderMessage : CSPSuccessToast);
                    setToastSuccess(true);
                    setSelectedOption(null);
                    setTimeout(() => {
                        setToastSuccess(false);
                    }, 5000);
                    setActionCompletedRefreshSubscriptionTable(true);
                     setIsActionInProgress(false);
                    console.log("auto refresh 1");
                    setIsAutoRefreshEnabled(true);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                setConfirmChangeStatusLoadingFlag(false);
                const msg = error.response?.data?.errors?.[0]?.toLowerCase();
                setToastMessage(msg?.includes("synnex accounts team") || msg?.includes("synnex credit team") ? error.response.data.errors[0] : selectedDate ? error.response.data.errors : ReactivationgErrorToast);  // check for account hold 1 & 2
                setToastError(true);
                setTimeout(() => {
                    setToastError(false);
                }, 5000);
                setIsActionInProgress(true);
                console.log("auto refresh 2");
                setIsAutoRefreshEnabled(false);

            })
    };

    //post api for Change-Status SUSPEND confirmation
    async function CSPChangeStatusSuspendPost(subscriptionId) {
        setConfirmChangeStatusLoadingFlag(true);
        let requestBody = {
            "subscriptionId": subscriptionId ,
            "scheduledDate": selectedDate ? new Date(new Date(selectedDate).getTime() + 19800000).toISOString().split('T')[0] : "",
            "planId": parseInt(subscriptionTableAPIData.planId)
         };
         await api.post(CSP_SUSPEND_STATUS_POST, requestBody, config)
            .then(resp => {
                if (resp.status = 200) {
                    setConfirmChangeStatusLoadingFlag(false);
                    setSubscriptionTableAPIData(null);
                    setChangeStatusActionPopupModalOpen(false);
                    setSelectedOption(null);
                    setToastMessage(resp.data.isOrderScheduled ? resp.data.scheduleOrderMessage : CSPSuccessToast);
                    setToastSuccess(true);
                    setTimeout(() => {
                        setToastSuccess(false);
                    }, 5000);
                    setActionCompletedRefreshSubscriptionTable(true);
                    setIsActionInProgress(false);
                    console.log("auto refresh 1");
                    setIsAutoRefreshEnabled(true);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                setConfirmChangeStatusLoadingFlag(false);
                setToastMessage(selectedDate ? error.response.data.errors :SuspendSubscriptionErrorToast);
                setToastError(true);
                setTimeout(() => {
                    setToastError(false);
                }, 5000);
                setIsActionInProgress(true);
                    console.log("auto refresh 1");
                    setIsAutoRefreshEnabled(false);

            })
    };

    //post api for Change-Status CANCEL confirmation
    async function CSPChangeStatusCancelPost(subscriptionId) {
        setConfirmChangeStatusLoadingFlag(true);
        await api.post(`${CSP_CANCEL_STATUS_POST}?subscriptionId=${subscriptionId}`, null, config)
            .then(resp => {
                if (resp.status = 200) {
                    setConfirmChangeStatusLoadingFlag(false);
                    setSubscriptionTableAPIData(null);
                    setChangeStatusActionPopupModalOpen(false);
                    setSelectedOption(null);
                    setToastMessage(CSPSuccessToast);
                    setToastSuccess(true);
                    setSelectedOption(null);
                    setTimeout(() => {
                        setToastSuccess(false);
                    }, 5000);
                    setActionCompletedRefreshSubscriptionTable(true);
                     setIsActionInProgress(false);
                    console.log("auto refresh 1");
                    setIsAutoRefreshEnabled(true);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                setConfirmChangeStatusLoadingFlag(false);
                setToastMessage(CancelSubscriptionErrorToast);
                setToastError(true);
                setTimeout(() => {
                    setToastError(false);
                }, 5000);
                 setIsActionInProgress(true);
                    console.log("auto refresh 1");
                    setIsAutoRefreshEnabled(false);

            })
    };

    // for displaying default table when popup is opened
    useEffect(() => {
        if (subscriptionTableAPIData && subscriptionTableAPIData.status === 'ACTIVE') {
            // console.log('useEffect is running: active',selectedOption);
            setSelectedOption('suspend');
        } else if (subscriptionTableAPIData && subscriptionTableAPIData.status === 'SUSPENDED') {
            // console.log('useEffect is running: suspend');
            setSelectedOption('reactivate');
        }
    }, [subscriptionTableAPIData]);

    return (
        <div>
            {/* For legacy and nce plan reactivate and suspend popup - confirmation */}
            <Popup
                className="custom-modal custom-modal-md"
                open={confirmSuspendFlag}
                onClose={() => { setConfirmSuspendFlag(false); }}
                modal
                nested
            >
                {(close) => (
                    <div className="modal">
                        <div className="header p-4 py-3">
                            <h2 className="mb-0 px-3">Change Status</h2>
                            <XLg
                                size={18}
                                className="cpointer text-strong close-icon-popup-sm"
                                onClick={close}
                                color={TEXT_SECONDARY}
                            />
                        </div>
                        <Container className={`p-5 `}>
                            <p className={`pt-0 px-3 pb-5 mb-0`}>
                                {subscriptionTableAPIData && selectedOption !== 'cancel' && (subscriptionTableAPIData.status === "ACTIVE" ? <strong>Are you sure you want to Suspend Subscription?</strong> : <strong>Are you sure you want to Re-Activate Subscription?</strong>)}
                                {subscriptionTableAPIData && selectedOption === 'cancel' && <strong>Are you sure you want to Cancel Subscription?</strong>}

                            </p>
                            <div className="actions">
                                <div className="d-flex justify-content-center pb-3 pt-2">
                                    <Button
                                        className="btn btn-lg mx-3 btn-border-light"
                                        variant="light"
                                        onClick={() => {
                                            close();
                                        }}
                                    >
                                        No
                                    </Button>
                                    <Button
                                        className="btn btn-md"
                                        onClick={() => {
                                            { subscriptionTableAPIData && selectedOption !== 'cancel' && (subscriptionTableAPIData.status === "ACTIVE" ? CSPChangeStatusSuspendPost(subscriptionId) : CSPChangeStatusReactivatePost(subscriptionId)) };
                                            { subscriptionTableAPIData && selectedOption === 'cancel' && CSPChangeStatusCancelPost(subscriptionId) }
                                            close();
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </div>
                            </div>
                        </Container>
                    </div>
                )}
            </Popup>

            {/* Change status Popup */}
            <Popup
                className="custom-modal custom-modal-xl"
                open={changeStatusActionPopupModalOpen}
                onClose={() => { setChangeStatusActionPopupModalOpen(false); setSubscriptionTableAPIData(null); setIsNcePlan(null);setSelectedDate("");setShowNote(false); }}
                modal
                closeOnDocumentClick={!confirmChangeStatusLoadingFlag}
                nested
            >
                {(close) => (
                    <div className="modal">
                        <>
                            <div className="header">
                                <h2>Change Status</h2>
                                <XLg
                                    size={18}
                                    className="cpointer text-strong"
                                    onClick={() => { if (!confirmChangeStatusLoadingFlag) close() }}
                                    color={TEXT_SECONDARY}
                                />
                            </div>
                            {/* For legacy plan */}
                            {!isNcePlan &&
                                <Container fluid className={`upgrade-modal-height ${styles['modal-width']}`}>
                                    {selectedOption === "reactivate" && (subscriptionTableAPIData?.isValidMpaStatus === false || subscriptionTableAPIData?.isValidPlaId === false) && <Card className={`mb-4 ml-3 mt-4 ${styles['error-card']}`}>
                                        <Card.Body className={`${styles['error-card']}`}><XCircle size={22} color={TOAST_ERROR_ICON_COLOR} className='mr-2' />{AddVendorRequirementsForPLAMPA}
                                            <span className='text-decoration-underline cpointer text-regular text-primary ml-1' onClick={() => navigate('/profile')}>Click here</span>
                                        </Card.Body>
                                    </Card>}
                                    <Box sx={{ width: '100%' }} className='mt-4 mb-4'>
                                        <React.Fragment>
                                            <Typography sx={{ mb: 1 }}>
                                                {subscriptionTableAPIData && (subscriptionTableAPIData.status === "ACTIVE" ? <p className='text-strong'>Suspend Subscription</p> : <p className='text-strong'>Re - Activate Subscription</p>)}
                                                <div className={`table-responsive ${styles['gws-downgrade-core']}`}>
                                                    {subscriptionTableAPIData &&
                                                    <>
                                                        <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                                                            <thead>
                                                                <tr>
                                                                    {subscriptionTableAPIData.status === "ACTIVE" ? ChangeStatusColumnNameSuspendLegacy.map(th => {
                                                                        return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : ""}>{th}</th>)
                                                                    }) :
                                                                        ChangeStatusColumnNameReActivate.map(th => {
                                                                            return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : ""}>{th}</th>)
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    <tr>
                                                                        <td>{subscriptionTableAPIData && subscriptionTableAPIData.planName}</td>
                                                                        <td>{subscriptionTableAPIData.planCode}</td>
                                                                        <td>{subscriptionTableAPIData && subscriptionTableAPIData.billingTerm}</td>
                                                                        {subscriptionTableAPIData && <td className='text-right'>${subscriptionTableAPIData.price}</td>}
                                                                        <td className='text-right'>{subscriptionTableAPIData && subscriptionTableAPIData.quantity}</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        {!subscriptionTableAPIData?.isOrderScheduled && <div className='mt-4'>
                                                          {/* <Form.Label className="w-auto mr-3" htmlFor="scheduleDate">Schedule Date : </Form.Label> */}
                                                            <Form.Label className="w-auto" htmlFor="scheduleDate">Schedule Date</Form.Label>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip className='tooltip-upgrade-destination'>
                                                                    {ScheduleOrderInfoNote}
                                                                </Tooltip>}
                                                            >
                                                                <span className="notes-confirmation infoIcon-support-table"></span>
                                                            </OverlayTrigger><span className='mr-3'>:</span>
                                                                <DatePicker
                                                                    showIcon
                                                                    selected={selectedDate}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onChange={(date) => {
                                                                        setSelectedDate(date);
                                                                        setShowNote(!!date); // Show note if a date is selected
                                                                    }}
                                                                    minDate={addDays(new Date(), 1)}
                                                                    maxDate={addDays(new Date(), 30)}
                                                                    placeholderText="DD/MM/YYYY"
                                                                    toggleCalendarOnIconClick
                                                                    isClearable={true}
                                                                    onKeyDown={handleKeyDown}
                                                                    onPaste={handlePaste}
                                                                />

                                                            </div>}
                                                        </>
                                                    }

                                                    {subscriptionTableAPIData && subscriptionTableAPIData.status === "ACTIVE" ? (
                                                        <ul className="mt-4 text-small px-3">
                                                            <strong>Note* :</strong>
                                                            <li className="mt-1 mb-0">{CSPChangeStatusNote1}</li>
                                                            <li className="mt-1 mb-0">{CSPChangeStatusNote2}</li>
                                                            {subscriptionTableAPIData?.isOrderScheduled && <li className="mt-1 mb-0">{ScheduleDateAllowanceNote}</li>}
                                                        </ul>
                                                    ) :
                                                        <ul className="mt-4 text-small px-3">
                                                            {(showNote || subscriptionTableAPIData?.isOrderScheduled) && <strong>Note* :</strong>}
                                                            {showNote && <li className="mt-1 mb-0">{GWSActivationFlexibleNote}</li>}
                                                            {subscriptionTableAPIData?.isOrderScheduled && <li className="mt-1 mb-0">{ScheduleDateAllowanceNote}</li>}
                                                        </ul>}

                                                    {!subscriptionTableAPIData &&
                                                        <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading Plan . . .</p></div>
                                                    }
                                                </div>
                                            </Typography>
                                            {/* buttons for change status legacy plan */}
                                            <div className='text-right'>
                                                <React.Fragment> 
                                                    {subscriptionTableAPIData?.status === "ACTIVE" ?
                                                    <>
                                                     {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && <Button
                                                        onClick={() => setConfirmSuspendFlag(true)}
                                                    >
                                                        Suspend Subscription
                                                    </Button>}
                                                    </>:
                                                        <>
                                                            {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (subscriptionTableAPIData?.isValidMpaStatus === true && subscriptionTableAPIData?.isValidPlaId === true) && <Button
                                                                onClick={() => setConfirmSuspendFlag(true)}
                                                            >
                                                                Re-Activate Subscription
                                                            </Button>}
                                                            {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (subscriptionTableAPIData?.isValidMpaStatus === false || subscriptionTableAPIData?.isValidPlaId === false) && <Button
                                                                disabled
                                                                className="ml-3 btn-border-light w-md-auto col-xs-12"
                                                                variant="light"  >
                                                                Re-Activate Subscription
                                                            </Button>}
                                                        </> }  
                                                     {/* {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (subscriptionTableAPIData?.isValidMpaStatus === true || subscriptionTableAPIData?.isValidPlaId === true) && <Button
                                                        onClick={() => setConfirmSuspendFlag(true)}
                                                    >
                                                        {subscriptionTableAPIData.status === "ACTIVE" ? "Suspend Subscription" : "Re-Activate Subscription"}
                                                    </Button>} */}
                                                    {confirmChangeStatusLoadingFlag && subscriptionTableAPIData && <Button
                                                        disabled
                                                        className="ml-3 btn-border-light w-md-auto col-xs-12"
                                                        variant="light"
                                                    >
                                                        Processing . . .
                                                    </Button>}
                                                </React.Fragment>
                                            </div>
                                        </React.Fragment>

                                    </Box>
                                </Container>}
                            {/* For Nce plan */}
                            {isNcePlan &&
                                <>
                                    <Container fluid className={`upgrade-modal-height ${styles['modal-width']}`}>
                                        {selectedOption === "reactivate" && (subscriptionTableAPIData?.isValidMpaStatus === false || subscriptionTableAPIData?.isValidPlaId === false) && <Card className={`mb-4 ml-3 mt-4 ${styles['error-card']}`}>
                                        <Card.Body className={`${styles['error-card']}`}><XCircle size={22} color={TOAST_ERROR_ICON_COLOR} className='mr-2' />{AddVendorRequirementsForPLAMPA}
                                            <span className='text-decoration-underline cpointer text-regular text-primary ml-1' onClick={() => navigate('/profile')}>Click here</span>
                                        </Card.Body>
                                    </Card>}
                                        <Box sx={{ width: '100%' }} className='mt-4 mb-4'>
                                            <React.Fragment>
                                                <Typography sx={{ mb: 1 }}>
                                                    <Container fluid>
                                                        {/* Top note showing cancellation note */}
                                                        {subscriptionTableAPIData && (subscriptionTableAPIData.isCancellationAllowed
                                                            ? <p className='text-small'><span className='text-extra-strong'>Note : </span>{ChangeStatusCancellationAllowedNote} {subscriptionTableAPIData.cancellationAllowedUntilDate}</p>
                                                            : <p className='text-small'><span className='text-extra-strong'>Note : </span>{ChangeStatus7DayCancellationNote}</p>)
                                                        }
                                                        <Row>
                                                            {/* 1st button tab: SUSPEND */}
                                                            {subscriptionTableAPIData && subscriptionTableAPIData.status === 'ACTIVE' &&
                                                                <Col md={3}>
                                                                    <label className='text-strong' >
                                                                        <input
                                                                            className='mr-1'
                                                                            type="radio"
                                                                            name="subscriptionOption"
                                                                            value="suspend"
                                                                            style={{ verticalAlign: 'top' }}
                                                                            checked={selectedOption === 'suspend'}
                                                                            onChange={() => handleOptionChange('suspend')}
                                                                        />
                                                                        Suspend Subscription
                                                                    </label>
                                                                </Col>}

                                                            {/* 2nd button tab: REACTIVATE */}
                                                            {subscriptionTableAPIData && subscriptionTableAPIData.status === 'SUSPENDED' &&
                                                                <Col md={3}>
                                                                    <label className='text-strong'>
                                                                        <input
                                                                            className='mr-1'
                                                                            type="radio"
                                                                            name="subscriptionOption"
                                                                            value="reactivate"
                                                                            style={{ verticalAlign: 'top' }}
                                                                            checked={selectedOption === 'reactivate'}
                                                                            onChange={() => handleOptionChange('reactivate')}
                                                                        />
                                                                        Re-Activate Subscription
                                                                    </label>
                                                                </Col>}
                                                            {/* 3rd button tab: CANCEL */}
                                                            {subscriptionTableAPIData && subscriptionTableAPIData.isCancellationAllowed === true &&
                                                                <Col md={3}>
                                                                    <label className='text-strong'>
                                                                        <input
                                                                            className='mr-1'
                                                                            type="radio"
                                                                            name="subscriptionOption"
                                                                            value="cancel"
                                                                            style={{ verticalAlign: 'top' }}
                                                                            checked={selectedOption === 'cancel'}
                                                                            onChange={() => handleOptionChange('cancel')}
                                                                        />
                                                                        Cancel Subscription
                                                                    </label>
                                                                </Col>}
                                                            {/* 4th Button tab: cancel disabled */}
                                                            {subscriptionTableAPIData && subscriptionTableAPIData.isCancellationAllowed === false &&
                                                                <Col md={3}>
                                                                    <label className='text-disabled text-strong'>
                                                                        <input
                                                                            className='mr-1'
                                                                            type="radio"
                                                                            name="subscriptionOption"
                                                                            value="disabled Cancel"
                                                                            style={{ verticalAlign: 'top' }}
                                                                            disabled
                                                                        />
                                                                        Cancel Subscription
                                                                    </label>
                                                                </Col>}
                                                        </Row>

                                                    </Container>
                                                    <div className={`table-responsive mt-4 ${styles['gws-downgrade-core']}`}>

                                                        {/* suspend reactivate nce subscription table */}
                                                        {(selectedOption === 'suspend' || 'reactivate' && selectedOption !== 'cancel') &&
                                                            <>
                                                                {/* loading state while table is not loaded */}
                                                                {!subscriptionTableAPIData &&
                                                                    <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading Plan . . .</p></div>
                                                                }
                                                                {subscriptionTableAPIData &&
                                                                <>
                                                                    <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                                                                        <thead>
                                                                            <tr>
                                                                                {subscriptionTableAPIData.status === "ACTIVE" ? ChangeStatusColumnNameSuspendNce.map(th => {
                                                                                    return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : ""}>
                                                                                        {th}
                                                                                    </th>)
                                                                                }) :
                                                                                    ChangeStatusColumnNameReActivate.map(th => {
                                                                                        return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : ""}>
                                                                                            {th}
                                                                                        </th>)
                                                                                    })
                                                                                }
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                <tr>
                                                                                    <td>{subscriptionTableAPIData.planName}</td>
                                                                                    <td>{subscriptionTableAPIData.planCode}</td>
                                                                                    <td>{subscriptionTableAPIData.billingTerm}</td>
                                                                                    <td className='text-right'>${subscriptionTableAPIData.price}</td>
                                                                                    <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                                                                    {subscriptionTableAPIData.status === "ACTIVE" && <td> {subscriptionTableAPIData.isCancellationAllowed ? "Yes" : "No"}</td>}
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    </Table>
                                                                    
                                                            {!subscriptionTableAPIData?.isOrderScheduled && <div className='my-3'>
                                                                <Form.Label className="w-auto" htmlFor="scheduleDate">Schedule Date</Form.Label>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip className='tooltip-upgrade-destination'>
                                                                        {ScheduleOrderInfoNote}
                                                                    </Tooltip>}
                                                                >
                                                                    <span className="notes-confirmation infoIcon-support-table"></span>
                                                                </OverlayTrigger><span className='mr-3'>:</span>                                                                
                                                                <DatePicker
                                                                    showIcon
                                                                    selected={selectedDate}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onChange={(date) => {
                                                                        setSelectedDate(date);
                                                                        setShowNote(!!date); // Show note if a date is selected
                                                                    }}
                                                                    minDate={addDays(new Date(), 1)}
                                                                    maxDate={addDays(new Date(), 30)}
                                                                    placeholderText="DD/MM/YYYY"
                                                                    toggleCalendarOnIconClick
                                                                    isClearable={true}
                                                                    onKeyDown={handleKeyDown}
                                                                    onPaste={handlePaste}
                                                                />
                                                            </div>}
                                                                    </>}
                                                            </>
                                                        }

                                                        {/* cancel subscription */}
                                                        {subscriptionTableAPIData && selectedOption === 'cancel' &&
                                                            <>{/* loading state while table is not loaded */}
                                                                {!subscriptionTableAPIData &&
                                                                    <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading Plan . . .</p></div>
                                                                }
                                                                {subscriptionTableAPIData &&
                                                                    <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                                                                        <thead className="sticky-top">
                                                                            <tr>
                                                                                {ChangeStatusNceColumnNameCancel.map(th => {
                                                                                    return (
                                                                                        <th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : ""}>
                                                                                            {th}
                                                                                        </th>
                                                                                    );
                                                                                })}
                                                                            </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                <tr>
                                                                                    <td>{subscriptionTableAPIData.planName}</td>
                                                                                    <td>{subscriptionTableAPIData.planCode}</td>
                                                                                    <td>{subscriptionTableAPIData.billingTerm}</td>
                                                                                    <td className='text-right'>${subscriptionTableAPIData.price}</td>
                                                                                    <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                                                                    <td>{subscriptionTableAPIData.cancellationAllowedUntilDate}</td>
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    </Table>}
                                                            </>
                                                        }
                                                        {/* last note in the screen for suspend and cancel subscription */}
                                                        {subscriptionTableAPIData && selectedOption === 'cancel' &&
                                                            <p className='text-small'><span className='text-extra-strong'>Note :</span> This is permanent deletion of subscription and it cannot be undone.
                                                                <p className='mx-9'>Full refund will be given incase subscription is cancelled within 24 hours of purchase. Post 24 hours proration charges will be applied.</p> </p>
                                                        }

                                                    {subscriptionTableAPIData?.status === "ACTIVE" && selectedOption === "suspend" ? (
                                                        <ul className="mt-4 text-small px-3">
                                                            <strong>Note* :</strong>
                                                            <li className="mt-1 mb-0">{CSPChangeStatusNote1}</li>
                                                            <li className="mt-1 mb-0">{CSPChangeStatusNote2}</li>
                                                            {subscriptionTableAPIData?.isOrderScheduled && <li className="mt-1 mb-0">{ScheduleDateAllowanceNote}</li>}
                                                        </ul>
                                                   ) :
                                                   <ul className="mt-4 text-small px-3">
                                                       {(showNote || subscriptionTableAPIData?.isOrderScheduled) && <strong>Note* :</strong>}
                                                       {showNote && <li className="mt-1 mb-0">{GWSActivationFlexibleNote}</li>}
                                                       {subscriptionTableAPIData?.isOrderScheduled && <li className="mt-1 mb-0">{ScheduleDateAllowanceNote}</li>}
                                                   </ul>}

                                                        {/* buttons for change status */}
                                                        <div className='text-right'>
                                                            <React.Fragment>
                                                                {/* re-active and suspend button */}
                                                                {subscriptionTableAPIData?.status === "ACTIVE" ?
                                                    <>
                                                     {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && selectedOption !== 'cancel' && <Button
                                                        onClick={() => setConfirmSuspendFlag(true)}
                                                    >
                                                        Suspend Subscription
                                                    </Button>}
                                                    </>:
                                                        <>
                                                            {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (subscriptionTableAPIData?.isValidMpaStatus === true && subscriptionTableAPIData?.isValidPlaId === true) && selectedOption !== 'cancel' && <Button
                                                                onClick={() => setConfirmSuspendFlag(true)}
                                                            >
                                                                Re-Activate Subscription
                                                            </Button>}
                                                            {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (subscriptionTableAPIData?.isValidMpaStatus === false || subscriptionTableAPIData?.isValidPlaId === false) && selectedOption !== 'cancel' && <Button
                                                                disabled
                                                                className="ml-3 btn-border-light w-md-auto col-xs-12"
                                                                variant="light"  >
                                                                Re-Activate Subscription
                                                            </Button>}
                                                        </> }  
                                                                {/* {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && (selectedOption === 'reactive' || 'suspend' && selectedOption !== 'cancel') && <Button
                                                                    onClick={() => setConfirmSuspendFlag(true)}
                                                                >
                                                                    {subscriptionTableAPIData && subscriptionTableAPIData.status === "ACTIVE" ? "Suspend Subscription" : "Re-Activate Subscription"}
                                                                </Button>} */}

                                                                {/* cancel button */}
                                                                {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && selectedOption === 'cancel' && <Button
                                                                    onClick={() => setConfirmSuspendFlag(true)}
                                                                > Cancel Subscription
                                                                </Button>}

                                                                {confirmChangeStatusLoadingFlag && subscriptionTableAPIData && <Button
                                                                    disabled
                                                                    className="ml-3 btn-border-light w-md-auto col-xs-12"
                                                                    variant="light"
                                                                >
                                                                    Processing . . .
                                                                </Button>}
                                                            </React.Fragment>
                                                        </div>
                                                    </div>
                                                </Typography>

                                            </React.Fragment>

                                        </Box>
                                    </Container>

                                </>
                            }
                        </>
                    </div>
                )
                }
            </Popup >
        </div >
    )
}


export default CSPChangeStatus
